var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:{ 'cursor-pointer' : _vm.onClick != null },on:{"click":_vm.handleClick}},[(_vm.valueCleaned === true)?_c('i',{staticClass:"fas fa-check text-green-600"}):(_vm.valueCleaned === false)?_c('i',{staticClass:"fas fa-times text-red-600"}):_c('i',[_vm._v(_vm._s(_vm.valueCleaned))])])
}
var staticRenderFns = []

export { render, staticRenderFns }